import axios from "axios";
import { userRequest } from "./requestMethods";

// Profile helpers for the authenticated customer.
//
// Reuses the same unsigned Cloudinary upload pattern as `reviewsApi.js`
// (cloud `lusuku`, preset `lusuku-clou`) and the authenticated `userRequest`
// axios instance (which attaches the bearer token from `persist:user`).

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "lusuku";
const UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "lusuku-clou";

/** Unsigned upload of a profile photo to Cloudinary. Returns the hosted URL. */
export const uploadProfileImage = async (file) => {
  const form = new FormData();
  form.append("file", file);
  form.append("upload_preset", UPLOAD_PRESET);
  form.append("folder", "profile_pictures");
  form.append("tags", "profile,user_generated");
  const { data } = await axios.post(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    form,
  );
  return { url: data.secure_url, publicId: data.public_id };
};

/**
 * Persist profile fields for the authenticated user via the shared backend
 * endpoint (writes `profilePicture` to the Users model so it flows into the
 * WhatsApp inbox avatar). Returns { success, accessToken, user }.
 */
export const updateMyProfile = async (payload) => {
  const { data } = await userRequest.put("/user/update-profile", payload);
  return data;
};

/**
 * PATCH /users/me/contact-email — attach a contact email to the signed-in
 * account.
 *
 * Always OPTIONAL. Most Lusuku customers register by phone and have no email at
 * all, so this backs the inline "we'll email you the ticket" prompt at checkout
 * rather than any kind of gate — a payment must never be blocked on it.
 * Resolves the API's `{ success, email, profile }` body.
 */
export const apiSetContactEmail = (email) =>
  userRequest.patch("/users/me/contact-email", { email }).then((r) => r.data);
